import { Auth } from '@ht-lib/vue-google-signin'
import { Vue } from 'vue-property-decorator'
import VueRouter, { Route } from 'vue-router'

export default class VueBase extends Vue {
  public $router!: VueRouter
  public $route!: Route
  public $auth!: Auth
}
